export default __webpack_public_path__ + "static/media/wholesalerStepImg_EN.da31bb9b.png";